import React from 'react';
import Home from './Home'
import Projects from './Projects'
import Contact from './Contact'

function App() {
	return (
		<>
			<Home />
			<Projects />
			<Contact />
		</>
	);
}

export default App;
